import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import Wordmark from "./Wordmark";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#060D17] text-slate-400">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Wordmark />
            <p className="mt-6 max-w-sm text-sm leading-relaxed">
              Wholesale air conditioning and refrigerated cooling solutions for residential, commercial and builder projects.
            </p>
          </div>

          <div>
            <h2 className="font-mono text-xs uppercase tracking-[0.24em] text-sky-300">Pages</h2>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" className="transition-colors hover:text-white" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-white" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/contact" className="transition-colors hover:text-white" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="font-mono text-xs uppercase tracking-[0.24em] text-sky-300">Call Us</h2>
            <a href="tel:+61448915019" data-testid="footer-phone" className="mt-5 inline-flex items-center gap-2.5 text-sm transition-colors hover:text-white">
              <Phone size={15} className="text-brand" aria-hidden="true" />
              <span>0448 915 019</span>
            </a>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6">
          <p className="text-xs" data-testid="footer-copyright">© 2025 GSMG INVESTMENTS. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
